export default __webpack_public_path__ + "assets/images/8bfbeca577057c35cb165f33eb1be49a.svg";